export const environment = 
{
    production: false,
    envName: "teal_comp",
    systemUserId: 0,

    harlowe:
    {
        tealcomp:
        {
            baseUri: "https://tealcomp.api.test.harlowehealth.com/tealcomp/api",
            coreApiUri: "https://tealcomp.api.test.harlowehealth.com/api",
            auth:
            {
                clientId: "081fc90d-571c-4ab0-bfc4-7461d902b7c8",
                authority: "https://login.microsoftonline.com/0c7cab0e-8f19-4bde-a901-4b7b35f056e3/",
                redirectUri: "https://tealcomp.test.harlowehealth.com",
                scopes:
                [
                    'api://081fc90d-571c-4ab0-bfc4-7461d902b7c8/Login'
                ]
            },
            signaling:
            {
                endpoints:
                {
                    messaging:"/signaling/messaging",
                    encounters:"/signaling/encounters",
                    referrals:"/signaling/referrals",
                    encounterDiaries:"/signaling/encounters/diaries",
                    encounterAppointments:"/signaling/encounters/appointments",
                    medicalBills:"/signaling/medicalbills",
                    finance:"/signaling/finance",
                    email:"/signaling/email",
                    emailTemplates:"/signaling/email/templates",

                }
            },
            encounters:
            {
                settings:
                {
                    activeFilter:"activeFilter"
                }
            },
            referrals:
            {
                submissionLink: 'https://form.jotform.com/240992866407064'
            },
            autologin:true,
            domain: "@teal-networks.com"
        }
    }
};
